@if (bidListVin) {
  <div class="missed-offer-alternative-slideout">
    <app-slide-out [body]="slideOutTemplate" [slideOutId]="'moaSlideOutId'"
    data-test-id="app-missed-offer-alternative-recommendations-e-slideout"></app-slide-out>
    <ng-template #slideOutTemplate>
      <div class="justify-content-between d-flex slideout-sticky-nav">
        <h5>{{missedOfferAlternativeTranslations.similarVehiclesHeader}}</h5>
        <button class="modal__close" data-track-name="close" (click)="slideOut.close()" data-track-elem="icon"
          data-track-trigger="close" data-test-id="app-missed-offer-alternative-recommendations-e-close-button">
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
      @if (moaVehicleRecommendationData.length > 0) {
        <div class="slideout-container">
          @for (vehicle of moaVehicleRecommendationData; track trackByInventoryItemUuid(i, vehicle); let i = $index) {
            <div>
              @if (selectedIndex == i) {
                <div>
                  <ng-container *ngTemplateOutlet="bidListError"></ng-container>
                </div>
              }
              <div class="d-flex flex-row">
                <app-add-remove-bid-list-button
                  [onBidList]="vehicle.onBidList"
                  [auctionItemUuid]="vehicle.auctionItemUuid"
                  [inventoryItemUuid]="vehicle.inventoryItemUuid"
                  [translations]="missedOfferAlternativeTranslations"
                  (errorMessage)="onErrorMessage($event, i)">
                </app-add-remove-bid-list-button>
                <div class="d-flex flex-column">
                  <a class="btn-link h6 fw-bold text-primary m-0 moa-link"
                    [attr.allytmln]="vehicle.inventoryItemUuid + ' - MOA VDP'"
                    data-test-id="app-missed-offer-alternative-recommendations-e-vdp-link"
                  [routerLink]="getBuyVdpLink(vehicle)">{{vdpLinkText(vehicle)}}</a>
                  <div class="fw-bold mb-2">{{vehicle.vin}}</div>
                </div>
              </div>
              <div class="d-flex flex-row">
                @if (!vehicle.imageId) {
                  <app-vehicle-icon></app-vehicle-icon>
                }
                @if (vehicle.imageId) {
                  <a (click)="getBuyVdpLink(vehicle)" data-test-id="app-missed-offer-alternative-recommendations-e-lead-image">
                    <img class="lead-image" [src]="vehicle.imageId" [alt]="'altTitle'" />
                  </a>
                }
                <div class="d-flex flex-column datalist-container ms-3">
                  <app-datalist-item class="mb-0" data-test-id="app-missed-offer-alternative-recommendations-e-location-datalist-item"
                    label="{{ missedOfferAlternativeTranslations.locationLabel }}"
                    [value]="vehicle.location">
                  </app-datalist-item>
                  <app-datalist-item class="mb-0" data-test-id="app-missed-offer-alternative-recommendations-e-odometer-datalist-item"
                    label="{{ missedOfferAlternativeTranslations.odometerLabel }}"
                    [value]="formatOdometer(vehicle.odometer)">
                  </app-datalist-item>
                  @if (!vehicle.openingPrice) {
                    <app-datalist-item class="mb-0" data-test-id="app-missed-offer-alternative-recommendations-e-current-bid-datalist-item"
                      label="{{ missedOfferAlternativeTranslations.currentBidLabel }}"
                      [value]="formatCurrency(vehicle.currentAmount)">
                    </app-datalist-item>
                  }
                  @if (vehicle.openingPrice) {
                    <app-datalist-item class="mb-0" data-test-id="app-missed-offer-alternative-recommendations-e-opening-price-datalist-item"
                      label="{{ missedOfferAlternativeTranslations.openingPriceLabel }}"
                      [value]="formatCurrency(vehicle.currentAmount)">
                    </app-datalist-item>
                  }
                  <app-datalist-item class="mb-0" label="{{missedOfferAlternativeTranslations.spreadToBookLabel}}"
                    value="{{ getSpreadToBookValue(vehicle.bookValues) ? (getSpreadToBookValue(vehicle.bookValues) * 100 | number: '1.0-0') + '%' : 'N/A'}}">
                    @if (getSpreadToBookValue(vehicle.bookValues)) {
                      <app-tooltip [tooltip]="spreadToBookTooltip" triggers="hover click :keydown.escape :keydown.tab"
                        data-test-id="app-missed-offer-alternative-recommendations-e-spread-to-book-percentage-tooltip"
                        >
                        <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
                      </app-tooltip>
                    }
                  </app-datalist-item>
                  <app-datalist-item class="mb-0" data-test-id="app-missed-offer-alternative-recommendations-e-buy-now-price-datalist-item"
                    label="{{ missedOfferAlternativeTranslations.buyNowPriceLabel }}"
                    [value]="formatBuyNowAmount(vehicle?.buyNowAmount)">
                  </app-datalist-item>
                  <div class="mark-reviewed d-flex flex-row" id="auction_info_mark_reviewed_checkbox">
                    <app-mark-reviewed-checkbox
                      [tenantName]="tenantName"
                      [sellerOeUuid]="vehicle.sellerOeUuid"
                      [inventoryItemUuid]="vehicle.inventoryItemUuid"
                      [vin]="vehicle.vin"
                      (markReviewed)="onMarkReviewed($event)"
                      (unmarkReviewed)="onUnmarkReviewed($event)"
                      [reviewed]="vehicle.reviewed"
                      [translations]="missedOfferAlternativeTranslations">
                    </app-mark-reviewed-checkbox>
                  </div>
                </div>
              </div>
              <hr class="divider">
            </div>
          }
        </div>
      } @else {
        @if (recommendationsHaveLoaded && moaVehicleRecommendationData.length < 1) {
          <div class="no-vehicles-message">
            <p>{{missedOfferAlternativeTranslations.noRecommendationsHeader}}</p>
          </div>
        }
        @if (!recommendationsHaveLoaded) {
          <div class="d-flex justify-content-center align-items-center text-center spinner-container">
            <app-spinner></app-spinner>
          </div>
        }
      }
    </ng-template>
  </div>
}

@if (!this.bidListVin) {
  <div class="missed-offer-alternative-widget grid-container border border-dark mt-4">
    <h2 class="header no-outline fw-bold"
    data-test-id="app-missed-offer-alternative-recommendations-e-header-text">{{ missedOfferAlternativeTranslations.recommendedForYouHeader }}</h2>
    @if (widgetError) {
      <div class="ms-3 mb-2">
        <ng-container *ngTemplateOutlet="bidListError"></ng-container>
      </div>
    }
    @if (moaVehicleRecommendationData.length > 0) {
      <div class="ms-2">
        <div class="grid-container">
          @for (vehicle of moaVehicleRecommendationData; track trackByInventoryItemUuid(i, vehicle); let i = $index) {
            <div class="grid-item d-flex align-items-stretch" [ngClass]="{'grid-item-error': selectedIndex == i}"
              >
              @if (!vehicle.imageId) {
                <app-vehicle-icon></app-vehicle-icon>
              }
              @if (vehicle.imageId) {
                <a
                  class="lead-image-container"
                  (click)="getBuyVdpLink(vehicle)"
                  data-test-id="app-missed-offer-alternative-recommendations-e-lead-image"
                >
                  <img class="lead-image" [src]="vehicle.imageId" [alt]="'altTitle'" />
                </a>
              }
              <div class="w-100 h-100 d-flex flex-column gap-2 p-2">
                <div class="d-flex gap-1">
                  <div class="add-remove-bidlist-container">
                    <app-add-remove-bid-list-button
                      [onBidList]="vehicle.onBidList"
                      [auctionItemUuid]="vehicle.auctionItemUuid"
                      [inventoryItemUuid]="vehicle.inventoryItemUuid"
                      [translations]="missedOfferAlternativeTranslations"
                      (errorMessage)="onErrorMessage($event, i)">
                    </app-add-remove-bid-list-button>
                  </div>
                  <div class="d-flex flex-column position-relative justify-content-center vdp-link-container moa-link">
                    <a class="btn-link widget-vdp fw-bold text-primary"
                      [attr.allytmln]="vehicle.inventoryItemUuid + ' - MOA VDP'"
                      data-test-id="app-missed-offer-alternative-recommendations-e-vdp-link"
                    [routerLink]="getBuyVdpLink(vehicle)">{{vdpLinkText(vehicle)}}</a>
                  </div>
                </div>
                <div class="d-grid d-sm-flex flex-md-row datalist-container justify-content-sm-between gap-3">
                  <div class="mb-0 app-datalist-item d-flex flex-column" data-test-id="app-missed-offer-alternative-recommendations-e-odometer-datalist-item">
                    <label class="fw-bold">{{ missedOfferAlternativeTranslations.odometerLabel }}</label>
                    <span>{{formatDistanceUnitAbbrev(vehicle.odometer)}}</span>
                  </div>
                  <div class="mb-0 app-datalist-item d-flex flex-column align-items-end align-items-md-start" data-test-id="app-missed-offer-alternative-recommendations-e-location-datalist-item">
                    <label class="fw-bold text-right text-md-left">{{ missedOfferAlternativeTranslations.distanceLabel }}</label>
                    <span>{{formatDistanceUnitAbbrev(vehicle.vehicleDistance)}}</span>
                  </div>
                  @if (!vehicle.openingPrice) {
                    <div class="mb-0 app-datalist-item d-flex flex-column" data-test-id="app-missed-offer-alternative-recommendations-e-current-bid-datalist-item">
                      <label class="fw-bold">{{ missedOfferAlternativeTranslations.currentBidLabel }}</label>
                      <span>{{formatCurrency(vehicle.currentAmount)}} {{formatSpreadToBookPercentage(vehicle?.bookValues)}}</span>
                    </div>
                  }
                  @if (vehicle.openingPrice) {
                    <div class="mb-0 app-datalist-item d-flex flex-column" data-test-id="app-missed-offer-alternative-recommendations-e-opening-price-datalist-item">
                      <label class="fw-bold">{{ missedOfferAlternativeTranslations.openingPriceLabel }}</label>
                      <span>{{formatCurrency(vehicle.currentAmount)}} {{formatSpreadToBookPercentage(vehicle?.bookValues)}}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <mat-paginator
          class = "justify-content: center"
          hidePageSize="true"
          [length]="totalLength"
          [pageSize]="getPageSize"
          (page)="handlePageEvent($event)">
        </mat-paginator>
      </div>
    } @else {
      @if (recommendationsHaveLoaded && moaVehicleRecommendationData.length < 1) {
        <div class="no-vehicles-message">
          <p>{{missedOfferAlternativeTranslations.noRecommendationsHeader}}</p>
        </div>
      }
      @if (!recommendationsHaveLoaded) {
        <div class="d-flex justify-content-center align-items-center text-center spinner-container">
          <app-spinner></app-spinner>
        </div>
      }
    }
  </div>
}

<ng-template #bidListError>
  <div class="error-container align-items-center d-flex flex-row p-0">
    <app-error-icon [remValue]="'16px'" [fill]="'#d42925'"></app-error-icon>
    @if (addOrRemoveErrorText) {
      <div class="error-text mb-2 mt-2 ms-2">{{missedOfferAlternativeTranslations.cannotAddToBidListError}}</div>
    }
    @if (!addOrRemoveErrorText) {
      <div class="error-text mb-2 mt-2 ms-2">{{missedOfferAlternativeTranslations.cannotRemoveFromBidListError}}</div>
    }
    @if(!recommendationsHaveLoaded) {
      <div class="d-flex justify-content-center align-items-center text-center spinner-container">
        <app-spinner></app-spinner>
      </div>
    }
  </div>
</ng-template>
